import ztComponent from './ztAutocomplete.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
